export default {
  "关注": "Following"
}



// WEBPACK FOOTER //
// ./src/languages/en/user.js